import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/impressum")({
  head: () => ({
    meta: [
      { title: "Impressum, OM Selected" },
      { name: "description", content: "Impressum und Anbieterkennzeichnung von OM Selected." },
      { name: "robots", content: "index, follow" },
      { property: "og:title", content: "Impressum, OM Selected" },
      { property: "og:description", content: "Impressum und Anbieterkennzeichnung von OM Selected." },
      { property: "og:url", content: "https://omselected.art/impressum" },
    ],
    links: [{ rel: "canonical", href: "https://omselected.art/impressum" }],
  }),
  component: ImpressumPage,
});

function ImpressumPage() {
  return (
    <article className="mx-auto max-w-2xl px-5 md:px-10 py-20 prose-invert">
      <h1 className="serif text-4xl md:text-5xl mb-10">Impressum</h1>

      <section className="space-y-2 text-sm leading-relaxed">
        <h2 className="eyebrow text-muted-foreground mt-8 mb-3">Anbieter</h2>
        <p>
          Vidhya Om<br />
          Steinentorstraße 18<br />
          4051 Basel<br />
          Schweiz
        </p>

        <h2 className="eyebrow text-muted-foreground mt-8 mb-3">Kontakt</h2>
        <p>
          E-Mail: <a href="mailto:kontakt@omselected.art" className="underline">kontakt@omselected.art</a>
        </p>

        <h2 className="eyebrow text-muted-foreground mt-8 mb-3">Verantwortlich für den Inhalt</h2>
        <p>Vidhya Om, Anschrift wie oben.</p>

        <h2 className="eyebrow text-muted-foreground mt-8 mb-3">Haftungsausschluss</h2>
        <p className="text-muted-foreground">
          Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
          Vollständigkeit und Aktualität der Inhalte kann jedoch keine Gewähr übernommen werden.
          Für Inhalte externer Links sind ausschließlich deren Betreiber verantwortlich.
        </p>

        <h2 className="eyebrow text-muted-foreground mt-8 mb-3">Urheberrecht</h2>
        <p className="text-muted-foreground">
          Alle auf dieser Website veröffentlichten Fotografien und Inhalte sind urheberrechtlich
          geschützt. Eine Verwendung, Vervielfältigung oder Weitergabe, auch auszugsweise, ist
          nur mit ausdrücklicher schriftlicher Zustimmung gestattet.
        </p>
      </section>
    </article>
  );
}